module.exports = __webpack_public_path__ + "static/media/ic_thumbs_up.e64ef714.svg";